// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"_3BDWJt2Ei1_services-landings","onScroll":"_2_tnxzKL2k_services-landings","full-screen":"_3qO3FE_IBv_services-landings"};